'use strict';

module.exports = function($scope, gettextCatalog, Notification, OfficeModel, officeResponse) {
  $scope.weekDays = [
    { name: gettextCatalog.getString('Monday') },
    { name: gettextCatalog.getString('Tuesday') },
    { name: gettextCatalog.getString('Wednesday') },
    { name: gettextCatalog.getString('Thursday') },
    { name: gettextCatalog.getString('Friday') },
    { name: gettextCatalog.getString('Saturday') },
    { name: gettextCatalog.getString('Sunday') },
  ];

  $scope.showValidation = false;
  $scope.office = officeResponse;
  $scope.openingHours = $scope.office.openingHours;

  $scope.$watch(
    'openingHours',
    function() {
      console.log('changed');
    },
    true,
  );

  /**
   * save to rest webservice
   */
  $scope.save = function() {
    $scope.showValidation = true;

    if ($scope.openingHoursForm.$valid) {
      OfficeModel.update($scope.office, function(error) {
        if (error) {
          Notification.addErrorMessage({ text: error });
        } else {
          Notification.addSuccessMessage(gettextCatalog.getString('Opening hours updated'));
        }
      });
    }
  };

  /**
   * add a second column to enable two time slots per day ...
   * @param day
   */
  $scope.addSecondOpeningTime = function(day) {
    // get closing hour of first opening time
    var firstClosingTime = $scope.openingHours.regular[day].times[0].end;

    $scope.openingHours.regular[day].times.push({
      start: firstClosingTime + 60 > 1440 ? 1440 : firstClosingTime + 60,
      end: firstClosingTime + 240 > 1440 ? 1440 : firstClosingTime + 240,
    });
  };

  /**
   * ... end make it removeable
   * @param day
   */
  $scope.removeSecondOpeningTime = function(day) {
    console.log($scope.openingHours.regular[day].times.length);
    $scope.openingHours.regular[day].times.splice(1, 1);
    console.log($scope.openingHours.regular[day].times.length);
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/openingHours/openingHoursCtrl.js